import * as React from 'react';
import { Ref, Segment, Table as UITable } from 'semantic-ui-react';
import { StatisticsTableDescription } from '~/InfoCard/Details/StatisticsTableDescription';
export var MonthlyPackageBalance = function (_a) {
    var headers = _a.headers, yearCounter = _a.yearCounter, detail = _a.detail, children = _a.children;
    var ref1 = React.useRef(null);
    var ref2 = React.useRef(null);
    var _b = React.useState([0, 0, 0]), margin = _b[0], setMargin = _b[1];
    React.useEffect(function () {
        if (ref1.current !== null && ref2.current !== null) {
            setMargin([ref1.current.offsetWidth, ref2.current.offsetWidth + ref1.current.offsetWidth]);
        }
    }, []);
    return (<div data-testid={detail.type}>
			{children}
			<Segment.Group compact>
				<UITable celled collapsing padded striped structured unstackable className='sticky-column-3-3' size='small'>
					<UITable.Header>
						<UITable.Row>
							<UITable.HeaderCell colSpan='3' style={{ left: 0 }}/>
							{Object.entries(yearCounter).map(function (_a) {
            var key = _a[0], value = _a[1];
            return (<UITable.HeaderCell colSpan={value * 3} key={key} textAlign='center'>
									{key}
								</UITable.HeaderCell>);
        })}
						</UITable.Row>
						<UITable.Row>
							<UITable.HeaderCell colSpan='3' style={{ left: 0 }}/>
							{headers.map(function (header) { return (<UITable.HeaderCell colSpan='3' data-testid='record-header' key={header} textAlign='center'>
									{new Intl.DateTimeFormat('cs-CZ', { month: 'long' }).format(new Date(header))}
								</UITable.HeaderCell>); })}
						</UITable.Row>
						<UITable.Row>
							<Ref innerRef={ref1}>
								<UITable.HeaderCell data-testid='record-header' style={{ left: 0 }}>
									Lečivý přípravek
								</UITable.HeaderCell>
							</Ref>
							<Ref innerRef={ref2}>
								<UITable.HeaderCell data-testid='record-header' style={{ left: margin[0] }}>
									Doplněk
								</UITable.HeaderCell>
							</Ref>
							<UITable.HeaderCell data-testid='record-header' style={{ left: margin[1] }}>
								SUKL kód
							</UITable.HeaderCell>
							{headers.map(function (_, j) { return (<>
									<UITable.HeaderCell singleLine key={j} textAlign='right'>
										Dodáno
									</UITable.HeaderCell>
									<UITable.HeaderCell singleLine key={j + 1} textAlign='right'>
										Vráceno
									</UITable.HeaderCell>
									<UITable.HeaderCell singleLine key={j + 2} textAlign='right'>
										Celkem
									</UITable.HeaderCell>
								</>); })}
						</UITable.Row>
					</UITable.Header>
					<UITable.Body>
						{detail.statistics.map(function (pack, i) { return (<UITable.Row data-testid='record' key={i}>
								<UITable.Cell singleLine style={{ left: 0 }}>
									{pack.brand}
								</UITable.Cell>
								<UITable.Cell singleLine style={{ left: margin[0] }}>
									{pack.supplement}
								</UITable.Cell>
								<UITable.Cell singleLine style={{ left: margin[1] }}>
									{pack.suklCode}
								</UITable.Cell>
								{headers.map(function (record, j) {
                var _a, _b, _c, _d, _e, _f;
                return (<>
										<UITable.Cell singleLine key={j} textAlign='right'>
											{(_b = (_a = pack.monthBalanceRecords[record]) === null || _a === void 0 ? void 0 : _a.positive) !== null && _b !== void 0 ? _b : 'No data'}
										</UITable.Cell>
										<UITable.Cell singleLine key={j + 1} textAlign='right'>
											{(_d = (_c = pack.monthBalanceRecords[record]) === null || _c === void 0 ? void 0 : _c.negative) !== null && _d !== void 0 ? _d : 'No data'}
										</UITable.Cell>
										<UITable.Cell singleLine key={j + 2} textAlign='right'>
											{(_f = (_e = pack.monthBalanceRecords[record]) === null || _e === void 0 ? void 0 : _e.total) !== null && _f !== void 0 ? _f : 'No data'}
										</UITable.Cell>
									</>);
            })}
							</UITable.Row>); })}
					</UITable.Body>
					<UITable.Footer>
						<UITable.Row data-testid='total'>
							<UITable.Cell colSpan='3' style={{ left: 0 }}>
								Total
							</UITable.Cell>
							{headers.map(function (record, j) {
            var _a, _b, _c, _d, _e, _f;
            return (<>
									<UITable.Cell singleLine key={j} textAlign='right'>
										{(_b = (_a = detail.overallStatistics[record]) === null || _a === void 0 ? void 0 : _a.positive) !== null && _b !== void 0 ? _b : 'No data'}
									</UITable.Cell>
									<UITable.Cell singleLine key={j + 1} textAlign='right'>
										{(_d = (_c = detail.overallStatistics[record]) === null || _c === void 0 ? void 0 : _c.negative) !== null && _d !== void 0 ? _d : 'No data'}
									</UITable.Cell>
									<UITable.Cell singleLine key={j + 2} textAlign='right'>
										{(_f = (_e = detail.overallStatistics[record]) === null || _e === void 0 ? void 0 : _e.total) !== null && _f !== void 0 ? _f : 'No data'}
									</UITable.Cell>
								</>);
        })}
						</UITable.Row>
					</UITable.Footer>
				</UITable>
			</Segment.Group>
			<StatisticsTableDescription />
		</div>);
};
